import { Link } from "react-router-dom";
import type { Cast } from "@/utils/catalog";

interface CastCardProps {
  cast: Cast;
}

export default function CastCard({ cast }: CastCardProps) {
  return (
    <Link
      to={`/detail/cast/${cast.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/70 bg-background-50 p-4 text-center transition hover:border-primary-300"
    >
      <div className="mx-auto h-24 w-24 overflow-hidden rounded-full bg-background-100">
        <img
          src={cast.avatar}
          alt={`${cast.name}（饰${cast.role}）`}
          title={`${cast.name} 演员资料`}
          className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
        />
      </div>
      <h3 className="mt-3 text-base font-medium text-foreground-900 transition group-hover:text-primary-600">
        {cast.name}
      </h3>
      <p className="mt-1 text-sm text-foreground-500">
        饰 <span className="text-foreground-800">{cast.role}</span>
      </p>
      <span className="mt-2 inline-block rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] text-accent-800">
        {cast.roleType}
      </span>
    </Link>
  );
}